import { IPublicClientApplication } from "@azure/msal-browser";

import { axiosGetRequest, axiosPostRequest } from "../../api/ApiClient";
import GenericUtils from "../../utils/GenericUtils";
import {
    IPostProcessWorkflow,
    ICheckinPendencies,
} from "../../context/interfaces/IWorkflowContext";

const route = "/docente/v1/workflows";

function getExtractHoursWorkflow(
    workflowId: number,
    processoId: number | undefined,
    instance: IPublicClientApplication
) {
    return axiosGetRequest(
        `${route}/${workflowId}/processos/${processoId}/extratohora`,
        GenericUtils.getAccessTokenDocente(),
        instance
    );
}

function getCheckinPendenciesWorkflow(
    workflowId: number,
    processoId: number | undefined,
    instance: IPublicClientApplication,
    isReadOnly: boolean
) {
    let url = `${route}/${workflowId}/processos/${processoId}/checkinpendentes`;

    if (isReadOnly) url = `${url}?visualizar=true`;

    return axiosGetRequest(url, GenericUtils.getAccessTokenDocente(), instance);
}

function getNotPerformedWorkflow(
    workflowId: number,
    processoId: number | undefined,
    instance: IPublicClientApplication
) {
    return axiosGetRequest(
        `${route}/${workflowId}/processos/${processoId}/cartoes?tipo=N`,
        GenericUtils.getAccessTokenDocente(),
        instance
    );
}

function getPerformedWorkflow(
    workflowId: number,
    processoId: number | undefined,
    instance: IPublicClientApplication
) {
    return axiosGetRequest(
        `${route}/${workflowId}/processos/${processoId}/cartoes?tipo=R`,
        GenericUtils.getAccessTokenDocente(),
        instance
    );
}

function endProcessWorkflow(
    workflowId: number,
    data: IPostProcessWorkflow,
    instance: IPublicClientApplication
) {
    return axiosPostRequest(
        `${route}/${workflowId}/processos`,
        data,
        GenericUtils.getAccessTokenDocente(),
        instance
    );
}

function updateCheckinPendencies(
    workflowId: number,
    processoId: number | undefined,
    data: ICheckinPendencies[],
    instance: IPublicClientApplication
) {
    return axiosPostRequest(
        `${route}/${workflowId}/processos/${processoId}/checkinpendentes`,
        data,
        GenericUtils.getAccessTokenDocente(),
        instance
    );
}

export default {
    getExtractHoursWorkflow,
    getCheckinPendenciesWorkflow,
    getNotPerformedWorkflow,
    getPerformedWorkflow,
    endProcessWorkflow,
    updateCheckinPendencies,
};
